import useGoBack from '@/hooks/useGoBack';
import SearchNavbarIcon from '@/shared-components/icons/components/navigation/SearchNavbarIcon';
import BackArrowIcon from '@/shared-components/icons/components/public/BackArrowIcon';
import OrderByPopup from '@/shared-components/popups/components/OrderByPopup';
import Heading from '@/shared-components/text/components/Heading';

import './styles/HomeHeader.css';

export default function HomeHeader({ onInput, value, icon, text, defaultOption, placeholder, type = "usual", onSort = () => {} }) {
  const goBackHandler = useGoBack("/");
  
  return (
    <>
      <div className="home-header__container element-non-selectable">
        <div className="home-header__back-section" onClick={goBackHandler}>
          <BackArrowIcon className="home-header__back-icon"/>

          {icon}

          <Heading className={`home-header__back-text ${!icon ? "no-icon" : ""}`} small>
            {text}
          </Heading>
        </div>
        { ["usual", ""].indexOf(type) !== -1 ?
          <div className="home-header__search-container">
            <SearchNavbarIcon className="home-header__search-icon"/>
            <input 
              type="text" 
              className="home-header__search-input" 
              value={value} 
              onInput={(e)=>onInput(e.target.value)} 
              placeholder={placeholder} 
              spellCheck={false} 
              autoComplete="off"
            />
          </div> :
          <div className="home-header__popup-container"> {
            ["theme", "emotion", "color"].indexOf(type) !== -1 ? 
              <OrderByPopup 
                defaultOption={defaultOption}
                options={["Default", "Recent", "Relevant", "High to low", "Low to high"]} 
                onChangeOption={onSort}
              />
              : 
              <OrderByPopup 
                defaultOption={defaultOption}
                options={["Relevant", "Recent", "High to low", "Low to high"]} 
                onChangeOption={onSort}
              /> }
          </div>
        }
      </div>
    </>
  );
}
